module.exports = __webpack_public_path__ + "static/media/email-verification.ad9370de.jpg";